import { create } from 'zustand';

const state = {
    theme: localStorage.getItem('theme') || 'dark', // 默认主题
};

let store = (set, get) => ({
    ...state,
    changeTheme: (theme) => {
        set({ theme });
    },
});

export const useUserStore = create(store);
